import { render, staticRenderFns } from "./SwatcherBulma.vue?vue&type=template&id=4962ae4c&scoped=true&"
import script from "./SwatcherBulma.vue?vue&type=script&lang=ts&"
export * from "./SwatcherBulma.vue?vue&type=script&lang=ts&"
import style0 from "./SwatcherBulma.vue?vue&type=style&index=0&id=4962ae4c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4962ae4c",
  null
  
)

export default component.exports